import React, { useState } from "react";
import "./HomeFAQ.scss";

import { ReactComponent as ArrUpp } from "../../assets/svg/ArrUp.svg";
import { ReactComponent as ArrDown } from "../../assets/svg/Arr-down.svg";

import { FaqData } from "../../data/data";

const HomeFAQ = () => {
  const [openQuestions, setOpenQuestions] = useState([]);

  const toggleAnswer = (index) => {
    setOpenQuestions((prevOpenQuestions) => {
      if (prevOpenQuestions.includes(index)) {
        return prevOpenQuestions.filter((i) => i !== index);
      }
      return [...prevOpenQuestions, index];
    });
  };

  return (
    <section className="section homeFAQ" id="FAQ">
      <article className="homeFAQ__container container">
        <div className="homeFAQ__container--header">
          <h2 className="homeFAQ__header-title">Frequently </h2>
          <h3 className="homeOffer__header-subtitle">asked questions</h3>
        </div>

        <div className="homeFAQ__container--contents">
          {FaqData.map((skills, index) => {
            const { id, title, answer } = skills;
            const isOpen = openQuestions.includes(index);
            return (
              <div
                className={`contents-question-item ${isOpen ? "open" : ""}`}
                key={id}
              >
                <div className="contents-question-item-header">
                  <h3 className="open-service">{title}</h3>
                  <button
                    type="button"
                    className={
                      isOpen
                        ? "open-service-btn active-open-btn"
                        : "open-service-btn"
                    }
                    onClick={() => toggleAnswer(index)}
                  >
                    {isOpen ? <ArrUpp /> : <ArrDown />}
                  </button>
                </div>

                {isOpen && (
                  <p className="contents-question-item-text">{answer}</p>
                )}
              </div>
            );
          })}
        </div>
      </article>
    </section>
  );
};

export default HomeFAQ;
